export const APP_NAME = 'KithFlow';
export const APP_DESCRIPTION =
  'UK B2B company intelligence, queryable by any AI agent. 5M+ Companies House records, enriched into sourced dossiers over MCP and REST.';
